import type {User} from '@/types'
import {getFileAssetUrl} from '@/utils/fileUrl'

export function getUserDisplayName(user?: User | null, fallback = '匿名') {
  return user?.profile?.nickname || user?.username || fallback
}

export function getUserAvatarUrl(user?: User | null) {
  return getFileAssetUrl(user?.profile?.avatarFile)
}

export function getUserInitial(user?: User | null, fallback = '?') {
  return getUserDisplayName(user, fallback).slice(0, 1).toUpperCase()
}
